<template>
  <!-- 合同管理  -->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="contractYear"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :deleteParam="deleteParam"
    >
    </x-tabula>

    <add-model ref='add'></add-model>
    <query-model ref='query'></query-model>
    <update-model ref='update'></update-model>
  </div>
</template>

<script>
import addModel from './addModel.vue';
import queryModel from './queryModel.vue';
import updateModel from './updateModel.vue';
import {fetchSelect} from '@/utils/mixins';
import { Modal } from 'ant-design-vue';
export default {
  mixins: [fetchSelect],
  name: 'contractManagement',
  components: {addModel, queryModel, updateModel},
  data () {
    return {
      searchList: [
        {
          props: ['contractYear'],
          placeholder: '合同年度',
          options: [],
          inputType: 'select'
        }
      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          handle: () => { this.$refs.add.show(); },
          permi: ['community:localContract:add']
        },
        {text: '删除', icon: 'close', disabled: true, permi: ['community:localContract:remove'] },
        {
          text: '修复缺失合同',
          icon: 'redo',
          disabled: true,
          handle: (selectid, rows) => {
            if (rows.length > 1) {
              Modal.error({
                content: '不支持多选'
              });
              return;
            }
            let str = '确定要修复该年度缺失合同？';
            let that = this;
            this.$confirm({
              content: str,
              okType: 'danger',
              centered: true,
              width: 440,
              okText: '确认',
              cancelText: '取消',
              onOk () {
                let ids = rows.map(row => row.contractYear).toString();
                that.synchronizeUpdates(ids);
              }
            });
          },
          permi: ['community:localContract:syncUpdateContractVerify']
        }
      ],
      rowOptList: [
        {
          text: '查看',
          handle: (row) => { this.$refs.query.show(row.contractYear); },
          key: '',
          //   this.$refs.table.toEdit(row),
          permi: ['community:localContract:annualContractList']
        },
        {
          text: '更新合同',
          handle: (row) => { this.$refs.update.show(row.contractYear); },
          key: '',
          //   this.$refs.table.toEdit(row),
          permi: ['community:localContract:edit']
        }
      ],
      columns: [
        {
          title: '合同年度',
          dataIndex: 'contractYear',
          align: '',
          width: '200'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dataSource: [],
      searchParams: {
        contractYear: undefined
      },

      listApi: {
        url: '/local/contract/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/local/contract/',
        param: {},
        title: '该合同年度',
        key: 'contractYear'
      }
    };
  },

  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: 0, scope: 'searchList', query: 'comu_local_annual_years'}
      ];
      this.dictionarySelect(paramArr);
    },
    synchronizeUpdates (contractYear) {
      this.$put({
        url: '/local/contract/syncUpdateContractVerify/' + contractYear,
        params: {
        }
      }).then((res) => {
        this.$message.success('操作成功');
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
</style>
